<template>
  <router-link :to="getRoute()">
    <slot>
      
    </slot>
  </router-link>
</template>

<script>
export default {
  props: {
    name:{
      type:String,
      required: true
    },
    id:Number
  },
  methods:{
    getRoute(){
      let params = null
      if(this.id!==null){
        params = {
          id:this.id
        }
      }else{
        params = {}
      }
      return {
        name:this.name,
        params:params
      }
    }
  }
}
</script>
